import { motion } from "framer-motion";
import Corners from "../wam/Corners";
import { hasApprovedTestimonials, REPLAY_CONFIG } from "@/config/replay";

export default function ReplayTestimonials() {
  const items = REPLAY_CONFIG.VERIFIED_PERMISSIONED_TESTIMONIALS_ONLY;
  if (!hasApprovedTestimonials()) {
    // TODO: Add SBA-approved, permissioned testimonials to
    // VERIFIED_PERMISSIONED_TESTIMONIALS_ONLY in /app/frontend/src/config/replay.js
    // to render this section. Do not fabricate testimonials.
    return null;
  }
  return (
    <section
      className="relative py-28 md:py-40 border-t wam-hairline"
      data-testid="replay-testimonials"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mb-10 flex items-center gap-4">
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [005] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            REAL CLIENT EXPERIENCES
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.slice(0, 3).map((t, i) => (
            <motion.div
              key={`${t.name}-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="relative border border-white/5 bg-white/[0.02] p-8"
              data-testid={`replay-testimonial-${i}`}
            >
              <Corners />
              <div className="font-display text-[28px] leading-none text-[#C9A84C]">&ldquo;</div>
              <p className="mt-3 font-body text-[14px] leading-[1.7] text-[#F0ECE4]/85">
                {t.quote}
              </p>
              <div className="mt-6 border-t wam-hairline pt-4">
                <div className="font-display text-[15px] tracking-[-0.02em]">
                  {t.name}
                </div>
                {t.company && (
                  <div className="mt-1 font-mono text-[9px] tracking-[0.24em] text-[#F0ECE4]/50">
                    {t.company}
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
